'use client';

import Image from 'next/image';
import { TelegramProductExtendedDto } from '@/generated';
import { useUserData } from '@/contexts/LoginContext';
import { useTranslations } from 'next-intl';
import { formatDateToDay } from '@/utils/formatDayOrTime';

type Props = {
  product: TelegramProductExtendedDto;
};

export const ProductPromotionBadges = ({ product }: Props) => {
  const userData = useUserData();
  const t = useTranslations('product');
  const isOwnProduct = product.telegramUserId === userData?.id;

  if (!isOwnProduct) {
    return null;
  }

  if (!product.isTopUp && !product.isPremium) {
    return null;
  }

  return (
    <div className='mt-[40px] w-full flex gap-[12px] md:flex-row flex-col'>
      {product.isTopUp && (
        <div className='h-[44px] w-full md:w-[50%] flex gap-[6px] items-center px-[12px] rounded-[12px] border border-solid border-primary-green-day bg-bg2-day'>
          <Image src='/assets/icons/monetization-top-up.svg' width={22} height={22} alt='' />
          <span className='text-primary font-medium'>
            {t('promotion_badge_top_up_header', { value: product.topUps?.count || 0 })}
          </span>

          <span className='text-[12px] font-normal text-text-disabled-day inline-block mt-[2px]'>
            {t('promotion_badge_top_up_date', { value: formatDateToDay(product.topUps?.expiresAt || '') })}
          </span>
        </div>
      )}

      {product.isPremium && (
        <div className='h-[44px] w-full md:w-[50%] flex gap-[6px] items-center px-[12px] rounded-[12px] border border-solid border-primary-green-day bg-bg2-day'>
          <Image src='/assets/icons/monetization-premium.svg' width={16} height={16} alt='' />
          <span className='text-primary font-medium'>{t('promotion_badge_premium')}</span>

          <span className='text-[12px] font-normal text-text-disabled-day inline-block mt-[2px]'>
            {t('promotion_badge_top_up_date', { value: formatDateToDay(product.premiumExpiresAt || '') })}
          </span>
        </div>
      )}
    </div>
  );
};
